export const StateList = [
  { name: "-", code: "00" },
  { name: "dolnośląskie", code: "824" },
  { name: "lubelskie", code: "826" },
  { name: "kujawsko-pomorskie", code: "825" },
  { name: "lubuskie", code: "828" },
  { name: "mazowieckie", code: "830" },
  { name: "małopolskie", code: "829" },
  { name: "opolskie", code: "831" },
  { name: "podkarpackie", code: "832" },
  { name: "podlaskie", code: "833" },
  { name: "pomorskie", code: "834" },
  { name: "warmińsko-mazurskie", code: "837" },
  { name: "wielkopolskie", code: "838" },
  { name: "zachodnipomorskie", code: "839" },
  { name: "łódzkie", code: "828" },
  { name: "śląskie", code: "835" },
  { name: "świętokrzyskie", code: "836" },
];
export default [
  { text: "-", value: "00" },
  { text: "dolnośląskie", value: "02" },
  { text: "kujawsko-pomorskie", value: "04" },
  { text: "lubelskie", value: "06" },
  { text: "lubuskie", value: "08" },
  { text: "mazowieckie", value: "14" },
  { text: "małopolskie", value: "12" },
  { text: "opolskie", value: "16" },
  { text: "podkarpackie", value: "18" },
  { text: "podlaskie", value: "20" },
  { text: "pomorskie", value: "22" },
  { text: "warmińsko-mazurskie", value: "28" },
  { text: "wielkopolskie", value: "30" },
  { text: "zachodnipomorskie", value: "32 " },
  { text: "łódzkie", value: "10 " },
  { text: "śląskie", value: "24 " },
  { text: "świętokrzyskie", value: "26" },
];

export const itemsGrpCod = [
  { ItmsGrpCod: 114, ItmsGrpNam: "U_Laboratorium" },
  { ItmsGrpCod: 115, ItmsGrpNam: "U_Usługi Serwisowe" },
  { ItmsGrpCod: 117, ItmsGrpNam: "U_Obsługa prawna" },
  { ItmsGrpCod: 116, ItmsGrpNam: "U_Szkolenia" },
  { ItmsGrpCod: 112, ItmsGrpNam: "U_Usługi" },
  { ItmsGrpCod: 104, ItmsGrpNam: "Koła" },
  { ItmsGrpCod: 100, ItmsGrpNam: "Do zdefiniowania" },
  { ItmsGrpCod: 101, ItmsGrpNam: "Przeprawy promowe" },
  { ItmsGrpCod: 106, ItmsGrpNam: "BHP" },
  { ItmsGrpCod: 109, ItmsGrpNam: "Ograniczniki prędkości" },
  { ItmsGrpCod: 108, ItmsGrpNam: "Ogrzewania postojowe" },
  { ItmsGrpCod: 103, ItmsGrpNam: "Tachografy" },
  { ItmsGrpCod: 107, ItmsGrpNam: "VDO Instrumenty" },
  { ItmsGrpCod: 105, ItmsGrpNam: "Wentylatory i dmuchawy" },
  { ItmsGrpCod: 102, ItmsGrpNam: "Środki Trwałe" },
  { ItmsGrpCod: 110, ItmsGrpNam: "TRUCK" },
  { ItmsGrpCod: 119, ItmsGrpNam: "e-TOLL" },
  { ItmsGrpCod: 113, ItmsGrpNam: "U_OSKP" },
  { ItmsGrpCod: 120, ItmsGrpNam: "Artykuły biurowe" },
  { ItmsGrpCod: 121, ItmsGrpNam: "Wyroby gotowe" },
  { ItmsGrpCod: 122, ItmsGrpNam: "U_BiR" },
];
export const assCod = [
  { AssortmentCode: "12V", Name: "12V", ItmsGrpCod: 105 },
  { AssortmentCode: "24V", Name: "24V", ItmsGrpCod: 105 },
  {
    AssortmentCode: "AkcesoriaTachografy",
    Name: "Akcesoria Tachografy",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "AkcesoriaTruck",
    Name: "Akcesoria Truck",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "AkcesoriaWentylatoryDmuchawy",
    Name: "Akcesoria Wentylatory i dmuchawy",
    ItmsGrpCod: 105,
  },
  { AssortmentCode: "Analogowe", Name: "Analogowe", ItmsGrpCod: 103 },
  { AssortmentCode: "CBRadio", Name: "CB radio", ItmsGrpCod: 110 },
  { AssortmentCode: "Cyfrowe", Name: "Cyfrowe", ItmsGrpCod: 103 },
  { AssortmentCode: "EBERSPACHER", Name: "EBERSPACHER", ItmsGrpCod: 108 },
  { AssortmentCode: "PozostałTruck", Name: "Pozostałe Truck", ItmsGrpCod: 110 },
  {
    AssortmentCode: "PozostałeOgrzewania",
    Name: "Pozostałe Ogrzewania",
    ItmsGrpCod: 108,
  },
  {
    AssortmentCode: "PozostałeTachografy",
    Name: "Pozostałe Tachografy",
    ItmsGrpCod: 103,
  },
  { AssortmentCode: "Przetworniki", Name: "Przetworniki", ItmsGrpCod: 103 },
  { AssortmentCode: "Przewody", Name: "Przewody", ItmsGrpCod: 103 },
  {
    AssortmentCode: "Prędkościomierze",
    Name: "Prędkościomierze",
    ItmsGrpCod: 103,
  },
  { AssortmentCode: "Termopapier", Name: "Termopapier", ItmsGrpCod: 103 },
  {
    AssortmentCode: "UrządzeniaKontrolne",
    Name: "Urządzenia kontrolne",
    ItmsGrpCod: 103,
  },
  { AssortmentCode: "Używane", Name: "Używane", ItmsGrpCod: 103 },
  { AssortmentCode: "WEBASTO", Name: "WEBASTO", ItmsGrpCod: 108 },
  { AssortmentCode: "Windy", Name: "Windy", ItmsGrpCod: 110 },
  { AssortmentCode: "Wykresówki", Name: "Wykresówki", ItmsGrpCod: 103 },
  {
    AssortmentCode: "ZabezpieczenieŁadunku",
    Name: "Zabezpieczenie ładunku",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "ZawiesiaPasowe",
    Name: "Zawiesia pasowe",
    ItmsGrpCod: 110,
  },
  { AssortmentCode: "Ochronadloni", Name: "Ochrona dłoni", ItmsGrpCod: 106 },
  { AssortmentCode: "Ochronaciała", Name: "Ochrona ciała", ItmsGrpCod: 106 },
  { AssortmentCode: "Ochronanóg", Name: "Ochrona nóg", ItmsGrpCod: 106 },
  {
    AssortmentCode: "Ochronadrógoddechowych",
    Name: "Ochrona dróg oddechowych",
    ItmsGrpCod: 106,
  },
  { AssortmentCode: "Ochronagłowy", Name: "Ochrona głowy", ItmsGrpCod: 106 },
  { AssortmentCode: "PozostałeBHP", Name: "Pozostałe BHP", ItmsGrpCod: 106 },
  { AssortmentCode: "P_PRZEW", Name: "WG Przewody", ItmsGrpCod: 121 },
  { AssortmentCode: "P_TT2010", Name: "WG TT2010", ItmsGrpCod: 121 },
];
export const subGroupCod = [
  {
    AssortmentCode: "1311-1314",
    Name: "1311-1314",
    U_GRMAT: "Tachografy",
    U_ASOR: "Analogowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "1318",
    Name: "1318",
    U_GRMAT: "Tachografy",
    U_ASOR: "Analogowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "1319",
    Name: "1319",
    U_GRMAT: "Tachografy",
    U_ASOR: "Analogowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "1324",
    Name: "1324",
    U_GRMAT: "Tachografy",
    U_ASOR: "Analogowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "ADAPTER",
    Name: "ADAPTER",
    U_GRMAT: "Tachografy",
    U_ASOR: "Przetworniki",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "Belki",
    Name: "Belki",
    U_GRMAT: "TRUCK",
    U_ASOR: "ZabezpieczenieŁadunku",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "Dmuchawy 12V",
    Name: "Dmuchawy 12V",
    U_GRMAT: "Wentylatory i dmuchawy",
    U_ASOR: "12V",
    ItmsGrpCod: 105,
  },
  {
    AssortmentCode: "Dmuchawy 24V",
    Name: "Dmuchawy 24V",
    U_GRMAT: "Wentylatory i dmuchawy",
    U_ASOR: "24V",
    ItmsGrpCod: 105,
  },
  {
    AssortmentCode: "Drążki",
    Name: "Drążki",
    U_GRMAT: "TRUCK",
    U_ASOR: "ZabezpieczenieŁadunku",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "Dywaniki",
    Name: "Dywaniki",
    U_GRMAT: "TRUCK",
    U_ASOR: "AkcesoriaTruck",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "HALLOTRONOWE",
    Name: "HALLOTRONOWE",
    U_GRMAT: "Tachografy",
    U_ASOR: "Przetworniki",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "INDUKCYJNE",
    Name: "INDUKCYJNE",
    U_GRMAT: "Tachografy",
    U_ASOR: "Przetworniki",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "KITAS",
    Name: "KITAS",
    U_GRMAT: "Tachografy",
    U_ASOR: "Przetworniki",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "Narzędzia",
    Name: "Narzędzia",
    U_GRMAT: "TRUCK",
    U_ASOR: "AkcesoriaTruck",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "Ochraniacze i maty",
    Name: "Ochraniacze i maty",
    U_GRMAT: "TRUCK",
    U_ASOR: "ZabezpieczenieŁadunku",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "Pasy",
    Name: "Pasy",
    U_GRMAT: "TRUCK",
    U_ASOR: "ZabezpieczenieŁadunku",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "Pistolety",
    Name: "Pistolety",
    U_GRMAT: "TRUCK",
    U_ASOR: "AkcesoriaTruck",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "Pobieranie danych",
    Name: "Pobieranie danych",
    U_GRMAT: "Tachografy",
    U_ASOR: "UrządzeniaKontrolne",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "PozostałeAkcesoria",
    Name: "Pozostałe Akcesoria",
    U_GRMAT: "TRUCK",
    U_ASOR: "AkcesoriaTruck",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "PozostałeAnalogowe",
    Name: "Pozostałe Analogowe",
    U_GRMAT: "Tachografy",
    U_ASOR: "Analogowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "Przewody elektryczne",
    Name: "Przewody elektryczne",
    U_GRMAT: "TRUCK",
    U_ASOR: "AkcesoriaTruck",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "Przewody spiralne",
    Name: "Przewody spiralne",
    U_GRMAT: "TRUCK",
    U_ASOR: "AkcesoriaTruck",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "SE5000,EFAS",
    Name: "SE5000,EFAS",
    U_GRMAT: "Tachografy",
    U_ASOR: "Cyfrowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "Siatki",
    Name: "Siatki",
    U_GRMAT: "TRUCK",
    U_ASOR: "ZabezpieczenieŁadunku",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "TT2010",
    Name: "TT2010",
    U_GRMAT: "Tachografy",
    U_ASOR: "UrządzeniaKontrolne",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "VDO 3.0",
    Name: "VDO 3.0",
    U_GRMAT: "Tachografy",
    U_ASOR: "Cyfrowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "VDO 4.0",
    Name: "VDO 4.0",
    U_GRMAT: "Tachografy",
    U_ASOR: "Cyfrowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "WORKSHOPTAB",
    Name: "WORKSHOPTAB",
    U_GRMAT: "Tachografy",
    U_ASOR: "UrządzeniaKontrolne",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "Wentylatory 12V",
    Name: "Wentylatory 12V",
    U_GRMAT: "Wentylatory i dmuchawy",
    U_ASOR: "12V",
    ItmsGrpCod: 105,
  },
  {
    AssortmentCode: "Wentylatory 24V",
    Name: "Wentylatory 24V",
    U_GRMAT: "Wentylatory i dmuchawy",
    U_ASOR: "24V",
    ItmsGrpCod: 105,
  },
  {
    AssortmentCode: "Zabezpieczenia",
    Name: "Zabezpieczenia",
    U_GRMAT: "TRUCK",
    U_ASOR: "AkcesoriaTruck",
    ItmsGrpCod: 110,
  },
  {
    AssortmentCode: "VDO 4.1",
    Name: "VDO 4.1",
    U_GRMAT: "Tachografy",
    U_ASOR: "Cyfrowe",
    ItmsGrpCod: 103,
  },
  {
    AssortmentCode: "WEBASTO ZESTAW",
    Name: "WEBASTO ZESTAW",
    U_GRMAT: "Ogrzewania postojowe",
    U_ASOR: "WEBASTO",
    ItmsGrpCod: 108,
  },
  {
    AssortmentCode: "WEBASTO CZĘŚCI",
    Name: "WEBASTO CZĘŚCI",
    U_GRMAT: "Ogrzewania postojowe",
    U_ASOR: "WEBASTO",
    ItmsGrpCod: 108,
  },
  {
    AssortmentCode: "EBERSPACHER CZĘŚCI",
    Name: "EBERSPACHER CZĘŚCI",
    U_GRMAT: "Ogrzewania postojowe",
    U_ASOR: "EBERSPACHER",
    ItmsGrpCod: 108,
  },
  {
    AssortmentCode: "EBERSPACHER ZESTAW",
    Name: "EBERSPACHER ZESTAW",
    U_GRMAT: "Ogrzewania postojowe",
    U_ASOR: "EBERSPACHER",
    ItmsGrpCod: 108,
  },
  {
    AssortmentCode: "Gumowe oraz z tworzyw",
    Name: "Gumowe oraz z tworzyw",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronadloni",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Ocieplane i termoodporne",
    Name: "Ocieplane i termoodporne",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronadloni",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Powlekane",
    Name: "Powlekane",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronadloni",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Specjalistyczne",
    Name: "Specjalistyczne",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronadloni",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Wzmacniane i skórzane",
    Name: "Wzmacniane i skórzane",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronadloni",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Kurtki",
    Name: "Kurtki",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronaciała",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Bluzy i polary",
    Name: "Bluzy i polary",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronaciała",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Spodnie",
    Name: "Spodnie",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronaciała",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Kamizelki",
    Name: "Kamizelki",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronaciała",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Koszulki",
    Name: "Koszulki",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronaciała",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Pozostałe Ochrona ciała",
    Name: "Pozostałe Ochrona ciała",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronaciała",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Sandały",
    Name: "Sandały",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronanóg",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Półbuty",
    Name: "Półbuty",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronanóg",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Trzewiki",
    Name: "Trzewiki",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronanóg",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Pozostałe Ocrona nóg",
    Name: "Pozostałe Ocrona nóg",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronanóg",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Maski",
    Name: "Maski",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronadrógoddechowych",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Filtry-pochłaniacze",
    Name: "Filtry-pochłaniacze",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronadrógoddechowych",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Kaski",
    Name: "Kaski",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronagłowy",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Czapki-czepki",
    Name: "Czapki-czepki",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronagłowy",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Okulary-google",
    Name: "Okulary-google",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronagłowy",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Nauszniki",
    Name: "Nauszniki",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronagłowy",
    ItmsGrpCod: 106,
  },
  {
    AssortmentCode: "Zatyczki",
    Name: "Zatyczki",
    U_GRMAT: "BHP",
    U_ASOR: "Ochronagłowy",
    ItmsGrpCod: 106,
  },
];
